import React from 'react';
import './Impressum.css';

function Datenschutz() {
  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <h1>Datenschutzerklärung</h1>
        
        <section>
          <h2>1. Verantwortlicher</h2>
          <p>
            Verantwortlicher für die Datenverarbeitung ist:
          </p>
          <p>
            <strong>Thomas Ringler</strong><br />
            Am Pfalzbach 52B<br />
            91413 Neustadt/Aisch<br />
            E-Mail: <a href="mailto:mail@thomas-ringler.de">mail@thomas-ringler.de</a>
          </p>
        </section>

        <section>
          <h2>2. Erhebung und Speicherung personenbezogener Daten</h2>
          <p>
            Bei der Nutzung von GarageDesk werden folgende personenbezogene Daten erhoben und gespeichert:
          </p>
          <ul>
            <li>Kontaktdaten (Name, Adresse, E-Mail, Telefonnummer)</li>
            <li>Fahrzeugdaten (Marke, Modell, Kennzeichen, VIN)</li>
            <li>Reparatur- und Rechnungsdaten</li>
            <li>Nutzungsdaten (Login-Zeiten, IP-Adressen)</li>
          </ul>
        </section>

        <section>
          <h2>3. Zweck der Datenverarbeitung</h2>
          <p>
            Die Daten werden ausschließlich für folgende Zwecke verarbeitet:
          </p>
          <ul>
            <li>Bereitstellung und Betrieb der Software</li>
            <li>Verwaltung von Kunden, Fahrzeugen und Reparaturen</li>
            <li>Erstellung von Rechnungen</li>
            <li>Kommunikation mit Nutzern</li>
            <li>Gewährleistung der Systemsicherheit</li>
          </ul>
        </section>

        <section>
          <h2>4. Rechtsgrundlage</h2>
          <p>
            Die Verarbeitung personenbezogener Daten erfolgt auf Grundlage von:
          </p>
          <ul>
            <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO (Berechtigtes Interesse)</li>
            <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, soweit erforderlich)</li>
          </ul>
        </section>

        <section>
          <h2>5. Datenweitergabe</h2>
          <p>
            Ihre Daten werden grundsätzlich nicht an Dritte weitergegeben. Ausnahmen gelten nur:
          </p>
          <ul>
            <li>bei gesetzlichen Verpflichtungen</li>
            <li>bei der Nutzung von Dienstleistern (z.B. Hosting), die als Auftragsverarbeiter tätig sind</li>
            <li>bei ausdrücklicher Einwilligung</li>
          </ul>
        </section>

        <section>
          <h2>6. Datensicherheit</h2>
          <p>
            Wir setzen umfassende technische und organisatorische Maßnahmen ein, um Ihre Daten zu schützen:
          </p>
          <ul>
            <li>Verschlüsselung der Datenübertragung (SSL/TLS)</li>
            <li>Regelmäßige Sicherheitsupdates</li>
            <li>Zugriffskontrollen und Authentifizierung</li>
            <li>Regelmäßige Backups</li>
            <li>Getrennte Datenbanken pro Mandant (Multi-Tenancy)</li>
          </ul>
        </section>

        <section>
          <h2>6.1. Transparente Datenspeicherung</h2>
          <p>
            GarageDesk speichert alle Daten in einem transparenten, offenen Format:
          </p>
          <ul>
            <li><strong>JSON-Format:</strong> Alle Daten werden als JSON (JavaScript Object Notation) gespeichert - ein offener, 
            standardisierter und menschenlesbarer Datenaustauschformat. Dies ist kein proprietäres Format, sondern ein 
            offener Standard, der von vielen Systemen und Tools unterstützt wird.</li>
            <li><strong>Datenbankstruktur:</strong> Die Daten sind in einer Datenbank organisiert und strukturiert gespeichert. 
            Die Datenbankstruktur ist transparent und nachvollziehbar.</li>
            <li><strong>Keine Vendor-Lock-in:</strong> Da wir kein proprietäres Datenformat verwenden, sind Ihre Daten jederzeit 
            exportierbar und können mit Standard-Tools gelesen und verarbeitet werden. Sie sind nicht an ein spezielles 
            System oder Format gebunden.</li>
            <li><strong>Vollständige Nachvollziehbarkeit:</strong> Die Datenstruktur ist transparent und nachvollziehbar. 
            Sie können jederzeit sehen, welche Daten wie gespeichert werden. Alle Daten sind in einem Format gespeichert, 
            das mit Standard-Tools gelesen werden kann.</li>
            <li><strong>Einfacher Export:</strong> Aufgrund des offenen Formats können Ihre Daten einfach exportiert und 
            in andere Systeme übertragen werden. Dies gewährleistet Ihre Datenportabilität und Unabhängigkeit.</li>
          </ul>
          <p>
            Diese Transparenz gewährleistet, dass Sie die volle Kontrolle über Ihre Daten haben und nicht von einem 
            speziellen Datenformat abhängig sind. Ihre Daten bleiben jederzeit zugänglich, nachvollziehbar und übertragbar.
          </p>
        </section>

        <section>
          <h2>7. Speicherdauer und Datenzugriff</h2>
          <p>
            Personenbezogene Daten werden nur so lange gespeichert, wie es für die Erfüllung der Zwecke 
            erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen. Nach Ablauf der Speicherfrist 
            werden die Daten gelöscht.
          </p>
          <p>
            <strong>Vollständige Transparenz und Kontrolle:</strong> GarageDesk wurde so konzipiert, dass Sie 
            jederzeit vollen Zugriff auf alle Ihre gespeicherten Daten haben. Alle in der Software gespeicherten 
            Daten sind für Sie vollständig einsehbar, abrufbar und können auf Wunsch vollständig gelöscht werden. 
            Diese Funktionen sind integraler Bestandteil der Software und stehen Ihnen jederzeit zur Verfügung.
          </p>
        </section>

        <section>
          <h2>8. Ihre Rechte</h2>
          <p>
            Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
          </p>
          <ul>
            <li><strong>Auskunft</strong> (Art. 15 DSGVO): Sie können jederzeit Auskunft über Ihre gespeicherten Daten verlangen. Alle in GarageDesk gespeicherten Daten sind für Sie vollständig einsehbar und abrufbar.</li>
            <li><strong>Berichtigung</strong> (Art. 16 DSGVO): Sie können die Berichtigung unrichtiger Daten verlangen. Sie können Ihre Daten direkt in der Software bearbeiten oder uns kontaktieren.</li>
            <li><strong>Löschung</strong> (Art. 17 DSGVO): Sie können jederzeit die Löschung Ihrer Daten verlangen. Alle gespeicherten Daten können vollständig und unwiderruflich gelöscht werden, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
            <li><strong>Einschränkung</strong> (Art. 18 DSGVO): Sie können die Einschränkung der Verarbeitung verlangen.</li>
            <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO): Sie können die Übertragung Ihrer Daten in einem strukturierten, gängigen und maschinenlesbaren Format verlangen.</li>
            <li><strong>Widerspruch</strong> (Art. 21 DSGVO): Sie können der Verarbeitung widersprechen.</li>
            <li><strong>Beschwerde</strong> (Art. 77 DSGVO): Sie können sich bei einer Aufsichtsbehörde beschweren.</li>
          </ul>
          <p>
            <strong>Wichtig:</strong> GarageDesk wurde so entwickelt, dass Sie jederzeit vollen Zugriff auf alle Ihre gespeicherten Daten haben. 
            Sie können alle Daten einsehen, exportieren und auf Wunsch vollständig löschen lassen. Diese Funktionen sind integraler 
            Bestandteil der Software und stehen Ihnen jederzeit zur Verfügung.
          </p>
        </section>

        <section>
          <h2>9. Cookies und Tracking</h2>
          <p>
            Wir verwenden technisch notwendige Cookies für die Funktionalität der Software. 
            Tracking- oder Werbe-Cookies werden nicht eingesetzt.
          </p>
        </section>

        <section>
          <h2>10. Kontakt</h2>
          <p>
            Bei Fragen zum Datenschutz können Sie uns jederzeit kontaktieren:
          </p>
          <p>
            E-Mail: <a href="mailto:mail@thomas-ringler.de">mail@thomas-ringler.de</a>
          </p>
        </section>

        <section>
          <h2>11. Änderungen dieser Datenschutzerklärung</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen. Die aktuelle Version ist 
            jederzeit auf dieser Seite abrufbar.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Datenschutz;

